import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { generateOtp, resetPassword, verifyOtp } from '../../../service/Otpservice';
import { Eye, EyeOff } from 'react-feather';
import { validateEmail, validatePassword } from '../../../config/function';
import '../../../styles/userLogin.css';
import { fetchCustomer } from '../../../service/CustomerService';
import { useToast } from '../../toast/ToastProvider';

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showValue, setShowValue] = useState(false);
  const [conformPassword, setConformPassword] = useState("");
  const [message, setMessage] = useState("");
  const [timeLeft, setTimeLeft] = useState('');
  const [showHint, setShowHint] = useState({ email: '', password: '', conformPassword: '' })
  const toast = useToast();

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [timeLeft])

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  }

  const handleOtpChange = (index, value) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        document.getElementById(`otp${index + 1}`)?.focus();
      }

    }
  }

  const handleSendOtp = async () => {
    if (!email) {
      setMessage("Please enter your email");
      return;
    }

    if (!validateEmail(email)) {
      setShowHint(prev => ({ ...prev, email: "Please enter a valid email address" }));
      return;
    } else {
      setShowHint(prev => ({ ...prev, email: "" }));
    }

    const customer = await fetchCustomer();
    const exist = customer.some(item=>item.email === email);

    if(!exist){
      setMessage('This email is not registered',"ERROR");
      toast("This email is not registered")
      return;
    }


    const res = await generateOtp(email);
    if (!res.error) {
      setMessage(`OTP sent to ${email}.`);
      setTimeLeft(300);
      setStep(2);
    } else {
      setMessage(res.message);
    }
  };

  const handleVerifyOtp = async () => {
    const enteredOtp = otp.join('');
    if (enteredOtp.length !== 6) {
      setMessage("please enter all 6 digits");
      return;
    }

    const res = await verifyOtp(email, enteredOtp);
    if (!res.error) {
      setMessage("OTP verified successfully");
      setStep(3);
    } else {
      setMessage(res.message);
    }
  }

  const handleResetPassword = async () => {
    if (!validatePassword(password)) {
      setShowHint(prev => ({ ...prev, password: "Password must be at least 8 characters, include one uppercase letter, one number, and one special character." }));
      return;
    }
    if (password !== conformPassword) {
      setMessage('password do not match');
    }

    const res = await resetPassword(email, password);
    if (!res.error) {
      setMessage("password reset successfully");
      // setStep(1);
      // setEmail('');
      setOtp('');
      setPassword('');
      setTimeout(() => {
        window.location.href = "/login"; 
      }, 2000);
    } else {
      setMessage(res.message);
    }
  }

  return (
    <div className="container-fluid vh-100">
      <div className="row h-100">
        <div className="col-lg-5 col-md-8 d-none d-md-block">
          <img
            src="https://manubhai.in/SocialMedia/post_artworks/02042018092243MBCC13.jpg?ver=2"
            alt="Forgot Password"
            className="img-fluid h-100 w-100"
            style={{ objectFit: "cover" }}
          />
        </div>

        <div className="col-lg-7 col-md-8 col-sm-12 d-flex align-items-center justify-content-center bg-light">
          <div className="w-75 p-5 shadow rounded-4 bg-white">
            <h2 className="mb-4 text-center fw-bold">Forgot Password </h2>

            {/* STEP 1: Email */}
            {step === 1 && (
              <Form.Group>
                <Form.Label className="auth-form-label">Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  className="auth-form-input"
                  onChange={(e) => {
                    const value = e.target.value;
                    setEmail(value);
                  }}
                />
                {showHint.email && (
                  <Form.Text className="show-hint">{showHint.email}</Form.Text>
                )}
                <div className="d-grid mt-4">
                  <Button
                    className="auth-form-btn fw-semibold"
                    onClick={handleSendOtp}
                  >
                    Send OTP
                  </Button>
                </div>
              </Form.Group>
            )}

            {/* STEP 2: OTP */}
            {step === 2 && (
              <>
                <Form.Group>
                  <Form.Label className="auth-form-label">
                    Enter OTP
                  </Form.Label>
                  <div className="d-flex justify-content-center gap-2 mb-3">
                    {otp.map((digit, index) => (
                      <Form.Control
                        key={index}
                        id={`otp${index}`}
                        type="text"
                        maxLength={1}
                        value={digit}
                        className="otp-box text-center"
                        onChange={(e) =>
                          handleOtpChange(index, e.target.value)
                        }
                      />
                    ))}
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="show-hint">
                      {timeLeft > 0
                        ? `Resend in ${formatTime(timeLeft)}`
                        : "OTP expired"}
                    </span>
                    <button
                      className="btn btn-link p-0 fw-semibold"
                      disabled={timeLeft > 0}
                      onClick={handleSendOtp}
                    >
                      Resend OTP
                    </button>
                  </div>
                  <div className="d-grid mt-4">
                    <Button
                      className="auth-form-btn fw-semibold"
                      onClick={handleVerifyOtp}
                    >
                      Verify OTP
                    </Button>
                  </div>
                </Form.Group>
              </>
            )}

            {/* STEP 3: Reset Password */}
            {step === 3 && (
              <>
                <Form.Group>
                  <Form.Label className="auth-form-label">
                    New Password
                  </Form.Label>
                  <div className="input-with-icon">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter new password"
                      value={password}
                      className="auth-form-input mb-3"
                      onChange={(e) => {
                        const value = e.target.value;
                        setPassword(value);
                        if (!value) {
                          setShowHint((prev) => ({ ...prev, password: "" }));
                        } else if (!validatePassword(value)) {
                          setShowHint((prev) => ({
                            ...prev,
                            password:
                              "Password must be at least 8 characters, include one uppercase letter, one number, and one special character.",
                          }));
                        } else {
                          setShowHint((prev) => ({ ...prev, password: "" }));
                        }
                      }}
                    />
                    <span onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <EyeOff /> : <Eye />}
                    </span>
                  </div>
                  {showHint.password && (
                    <Form.Text className="show-hint">
                      {showHint.password}
                    </Form.Text>
                  )}
                </Form.Group>

                <Form.Group className="mt-3">
                  <Form.Label className="auth-form-label">
                    Confirm Password
                  </Form.Label>
                  <div className="input-with-icon">
                    <Form.Control
                      type={showValue ? "text" : "password"}
                      placeholder="Re-enter password"
                      value={conformPassword}
                      className="auth-form-input"
                      onChange={(e) => {
                        const value = e.target.value;
                        setConformPassword(value);
                        if (value !== password) {
                          setShowHint((prev) => ({
                            ...prev,
                            confirmPassword: "Passwords do not match",
                          }));
                        } else {
                          setShowHint((prev) => ({
                            ...prev,
                            confirmPassword: "",
                          }));
                        }
                      }}
                    />
                    <span onClick={() => setShowValue(!showValue)}>
                      {showValue ? <EyeOff /> : <Eye />}
                    </span>
                  </div>
                  {showHint.confirmPassword && (
                    <Form.Text className="show-hint">
                      {showHint.conformPassword}
                    </Form.Text>
                  )}
                </Form.Group>

                <div className="d-grid mt-4">
                  <Button
                    className="auth-form-btn fw-semibold"
                    onClick={handleResetPassword}
                    disabled={
                      !password ||
                      !conformPassword ||
                      password !== conformPassword
                    }
                  >
                    Reset Password
                  </Button>
                </div>
              </>
            )}

            {message && (
              <p className="text-center mt-3 text-success">{message}</p>
            )}

            <div className="text-center mt-4">
              <Button
                variant="link"
                className="p-0 fw-semibold text-decoration-none"
                onClick={() => (window.location.href = "/login")}
              >
                Back to Login
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
